/* Rabatt-Pille auf Produktkacheln und kürzere Variantennamen (gemeinsamen Anfang/Ende weglassen) */
(function () {
  'use strict';
  function zahl(t) {
    var m = (t || '').replace(/\s/g, '').match(/(\d+(?:\.\d{3})*(?:,\d+)?)/);
    return m ? parseFloat(m[1].replace(/\./g, '').replace(',', '.')) : NaN;
  }
  function rabatte() {
    document.querySelectorAll('.armano-products__card').forEach(function (c) {
      if (c.querySelector('.ct-rabatt')) return;
      var neu = c.querySelector('.armano-products__price-sale'), alt = c.querySelector('.armano-products__price del');
      var media = c.querySelector('.armano-products__info');
      if (!neu || !alt || !media) return;
      var a = zahl(alt.textContent), n = zahl(neu.textContent);
      if (!(a > n && n > 0)) return;
      var p = Math.round((1 - n / a) * 100);
      if (p < 1) return;
      var s = document.createElement('span');
      s.className = 'ct-rabatt';
      s.textContent = '\u2212' + p + ' %';
      media.appendChild(s);
    });
  }
  function namen() {
    document.querySelectorAll('.swatch-view-image').forEach(function (g) {
      var ps = Array.prototype.slice.call(g.querySelectorAll('.swatch-img-text-adjacent p'));
      if (ps.length < 2) return;
      var t = ps.map(function (p) { return p.getAttribute('data-ct-voll') || p.textContent.trim(); });
      var w = t.map(function (x) { return x.split(/\s+/); });
      var vorn = 0, hinten = 0, min = Math.min.apply(null, w.map(function (x) { return x.length; }));
      while (vorn < min - 1 && w.every(function (x) { return x[vorn] === w[0][vorn]; })) vorn++;
      while (hinten < min - 1 - vorn && w.every(function (x) { return x[x.length - 1 - hinten] === w[0][w[0].length - 1 - hinten]; })) hinten++;
      if (!vorn && !hinten) return;
      ps.forEach(function (p, i) {
        var teile = w[i].slice(vorn, w[i].length - hinten);
        while (teile.length && /^[-\/–|]$/.test(teile[0])) teile.shift();
        while (teile.length && /^[-\/–|]$/.test(teile[teile.length - 1])) teile.pop();
        if (!teile.length) return;
        p.setAttribute('data-ct-voll', t[i]);
        p.setAttribute('title', t[i]);
        p.textContent = teile.join(' ');
      });
    });
  }
  function alles() { rabatte(); namen(); }
  function los() {
    alles();
    var z = 0, mo = new MutationObserver(function () { clearTimeout(z); z = setTimeout(alles, 80); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
